import { render, staticRenderFns } from "./TestVideoPollQuestions.vue?vue&type=template&id=8fc42e4e&scoped=true&"
import script from "./TestVideoPollQuestions.vue?vue&type=script&lang=js&"
export * from "./TestVideoPollQuestions.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoPollQuestions.vue?vue&type=style&index=0&id=8fc42e4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc42e4e",
  null
  
)

export default component.exports